import { render } from "./Footer.vue?vue&type=template&id=7d0256bf&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=7d0256bf&scoped=true&lang=css"

import exportComponent from "/Users/myeonghoonjeon/git/pawinhand_shelter_manager/PawinhandAPIServer/front/pawinhand_shelter_manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d0256bf"]])

export default __exports__